const opendoorBlue = '#1C85E8';

const opendoorBlueHover = '#54A3ED';

const palette = {
  black: '#191919',
  blue: opendoorBlue,
  blueHover: opendoorBlueHover,
  grey100: '#e0e0e0',
  grey200: '#aeaeb1',
  grey300: '#7c7c81',
  grey400: '#666666',
  grey600: '#00023f',
  grey700: '#181b31',
  placeholder: opendoorBlue,
};

const colors = {
  active: palette.placeholder,
  black: palette.black,
  currentSession: palette.black,
  error: palette.blue,
  form: palette.placeholder,
  homeAuto: palette.placeholder,
  hover: palette.blueHover,
  info: palette.blue,
  mortgage: palette.placeholder,
  primary: palette.blue,
  realEstate: palette.placeholder,
  savings: palette.placeholder,
  secondary: palette.grey700,
  text: palette.grey200,
  textDark: palette.grey600,
  textDarker: palette.grey400,
  transparentPrimary: palette.placeholder,
  white: '#ffffff',
};

export {
  palette, colors,
};
